import { RialSign } from "@/components/RialSign";
import { PageHeader } from "@/components/PageHeader";
import { useAuth } from "@/context/AuthContext";

export default function SettingsPage() {
  const { user } = useAuth();
  return (
    <div className="max-w-3xl space-y-8" data-testid="settings-page">
      <PageHeader eyebrow="Tools" title="Settings" subtitle="Your account." />
      <section className="rise-in rounded-lg border border-slate-200 bg-white p-6 shadow-sm">
        <h2 className="text-base font-semibold text-slate-900 md:text-lg">Account</h2>
        <dl className="mt-3 grid grid-cols-[120px_1fr] gap-y-2 text-sm">
          <dt className="text-slate-500">Email</dt><dd className="text-slate-900" data-testid="settings-email">{user?.email}</dd>
          <dt className="text-slate-500">Role</dt><dd className="text-slate-900">Super admin</dd>
          <dt className="text-slate-500">Currency</dt><dd className="text-slate-900">Omani Rial (<RialSign className="!mr-0" />) · 3 decimals</dd>
          <dt className="text-slate-500">Data</dt><dd className="text-slate-900">Sales, Outstanding and Expenses uploads only</dd>
        </dl>
      </section>
    </div>
  );
}
